import queryString from "query-string";
import clientChatUrl from "/auto-message/src/common/js/lib/clientChatUrl";
import { backendApiUrl } from "/auto-message/src/ENV";

const parsedQueryString = queryString.parse(location.search);
const parentDomain = decodeURIComponent(parsedQueryString.visitorDomain);

export default {
  parentDomain,
  clientChatUrl,
  backendApiUrl,
};



// WEBPACK FOOTER //
// ./lib/Constant.js